import {Component, HostBinding, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

import { Subscription } from 'rxjs';
import { ReportPageConstant } from 'src/app/constants/reportPage.constants';
import { ReportPageInterface } from 'src/app/interface';
import { FieldValue, FieldValueReset, Report } from 'src/app/model';
import { FooterButtonOption, OwnerLeave, PageNumbers } from 'src/app/model/Enums';
import { ReportProvider } from 'src/app/providers';
import { ReportService, ToasterService } from 'src/app/services';
import { radioGroupOption } from '../../commonModel/common-classes';
import {routeTransition} from '../../../../animations/route-transition';

@Component({
  selector: 'app-personal-goodwill',
  templateUrl: './personal-goodwill.component.html',
  styleUrls: ['./personal-goodwill.component.scss'],
  animations: [routeTransition],
})
export class PersonalGoodwillComponent implements OnInit, OnDestroy,ReportPageInterface {
  @HostBinding('@routeTransition') routeAnimation = true;
  @ViewChild('personalGoodwillForm') personalGoodwillForm: NgForm;

  goodwillList: radioGroupOption[] = [];

  public currentReport: Report;
  private reportSub: Subscription;
  reportPageConst = ReportPageConstant;

  constructor(private reportService: ReportService,
    private reportProvider: ReportProvider,
    private router: Router,
    private toastr: ToasterService) { }

  ngOnInit(): void {
    this.goodwillList.push({ title: 'No Change', text: 'Responsibilities can be fully transferred with no impact on the company.', value: OwnerLeave.NO_CHANGE });
    this.goodwillList.push({ title: 'Manageable', text: 'A replacement can be found with minimal disruption to operations.', value: OwnerLeave.FINDING_INDIVIDUAL_EASY });
    this.goodwillList.push({ title: 'Difficult', text: 'Finding a qualified replacement would be challenging and could disrupt the business.', value: OwnerLeave.FINDING_INDIVIDUAL_DIFFICULT });
    this.goodwillList.push({ title: 'Difficult with Loss', text: 'Finding a replacement would be difficult, and significant client loss is likely.', value: OwnerLeave.FINDING_INDIVIDUAL_DIFFICULT_WITH_LOSS });

    this.reportSub = this.reportService.report$.subscribe(currentReport => {
      this.currentReport = currentReport;
    });
  }

  ngOnDestroy(): void {
    if(this.reportSub)
      this.reportSub.unsubscribe();
  }

  /**
   * @description field update API
   * @param event seleted event
   */
  callUpdateAPI() {
    let objFieldValue = new FieldValue();
    objFieldValue.GROUP = 'RISK';
    objFieldValue.FIELD = 'PG_OWNER_LEAVE';
    objFieldValue.VALUE = this.currentReport.LATEST.RISK.PG_OWNER_LEAVE;
    this.reportProvider.updateReportField(this.currentReport.LATEST.ID, objFieldValue).subscribe(res => {
      if (!res.success) {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description field reset API
   */
  resetFieldAPI() {
    this.currentReport.LATEST.RISK.PG_OWNER_LEAVE = null;
    let objFieldValueReset = new FieldValueReset();
    objFieldValueReset.GROUP = 'RISK';
    objFieldValueReset.FIELD_LIST = ['PG_OWNER_LEAVE'];
    this.reportProvider.resetReportField(this.currentReport.LATEST.ID, objFieldValueReset).subscribe(res => {
      if (!res.success) {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });

  }

  showHidePersonalGoodwill() {
    this.currentReport.LATEST.RISK.OPT_PG = !this.currentReport.LATEST.RISK.OPT_PG;
    let fieldName = 'OPT_PG';
    let objFieldValue = new FieldValue();
    objFieldValue.GROUP = 'RISK';
    objFieldValue.FIELD = fieldName;
    objFieldValue.VALUE = this.currentReport.LATEST.RISK[fieldName];
    this.reportProvider.updateReportField(this.currentReport.LATEST.ID, objFieldValue).subscribe(res => {
      if (!res.success) {
        this.toastr.error(res.error.txt);
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description function of interface for validation
   * @returns form valid or not
   */
  isFormValid(): boolean {
    return this.personalGoodwillForm.valid || this.currentReport?.isLocked;
  }

  /**
   * @description function of interface for skip functionality
   * @returns form can be skippable or not
   */
  canBeSkipped(): boolean {
    return false;
  }

  /**
   * @description report footer button click options
   * @param buttonOption which button clicked by user
   */
  footerButtonClick(buttonOption: number) {
    if (buttonOption == FooterButtonOption.NEXT_CLICK) {
      this.reportService.updateMaxStage(PageNumbers.PERSONAL_GOODWILL);
      this.router.navigateByUrl(`/report/${this.currentReport.ID}/risk/barriers-entry`);
    } else if (buttonOption == FooterButtonOption.BACK_CLICK) {
      this.router.navigateByUrl(`/report/${this.currentReport.ID}/risk/diversification`);
    } else if (buttonOption == FooterButtonOption.SKIP_CLICK) {
      this.reportService.updateMaxStage(PageNumbers.PERSONAL_GOODWILL, true);
      this.resetFieldAPI();
    } else if (buttonOption == FooterButtonOption.EXTRA_CLICK) {
      this.showHidePersonalGoodwill();
    }
  }

}
